import { useSelector } from "react-redux"

import { KpiCardsGrid } from "../../../components/KpiCards/KpiCardsGrid"
import { selectKpi, selectKpiFetching } from "../../redux/compelling-evidence.slice"
import { buildKpiCards } from "./kpiCards"

export const KpiCards = () => {
  const kpi = useSelector(selectKpi)
  const loading = useSelector(selectKpiFetching)

  return <KpiCardsGrid cards={buildKpiCards(kpi)} loading={loading} />
}
